import type { AccountManagementService } from "@/domain/port/AccountManagementService";
import type { IdempotencyKeyFactory } from "../port/IdempotencyKeyFactory";
import type { CancelBillingResult } from "../model/AccountBilling";

export class CancelAccountBilling {
  constructor(
    private readonly service: AccountManagementService,
    private readonly idempotencyKeyFactory: IdempotencyKeyFactory,
  ) {}

  execute(
    cancelAtPeriodEnd: boolean,
    signal?: AbortSignal,
  ): Promise<CancelBillingResult> {
    return this.service.cancelBilling(
      cancelAtPeriodEnd,
      this.idempotencyKeyFactory.create(),
      signal,
    );
  }
}
